import { Box, colors, Typography, useTheme } from "@mui/material";
import React from "react";
import { IStepItem } from "..";
import { blueGrey } from "@mui/material/colors";

export default function StepItem(props: IStepItem) {
  const theme = useTheme();

  const { Icon, index, status, title } = props;

  const color =
    status === "done"
      ? theme.palette.success.main
      : status === "error"
      ? theme.palette.error.main
      : status === "inprogress"
      ? theme.palette.secondary.main
      : colors.blueGrey[400];
  return (
    <Box
      // onClick={() => handleClickItem(index)}
      sx={{
        cursor: "pointer",
        flex: index !== 4 ? 1 : 0,
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "3px",
        }}
      >
        <Box
          sx={{
            backgroundColor: blueGrey[50],
            padding: "8px 4px",
            borderRadius: "8px",
          }}
        >
          {Icon(color)}
        </Box>
        {index !== 4 && (
          <div
            style={{
              height: "1px",
              backgroundColor: color,
              width: "100%",
            }}
          ></div>
        )}
      </Box>
      <Box>
        <Typography
          sx={{
            fontSize: "12px",
            color: color,
            fontWeight: "700",
          }}
        >
          <div
            style={{
              whiteSpace: "nowrap",
            }}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </Typography>
      </Box>
    </Box>
  );
}
